import { createContext, useContext } from 'react'

/**
 * Share Token Context
 *
 * Provides a share token to widget data hooks so they can route
 * API calls through the public shared endpoints instead of
 * authenticated endpoints.
 *
 * When null (default), hooks use normal authenticated endpoints.
 * When set, hooks use /dashboards/shared/{token}/aggregate/ etc.
 */
const ShareTokenContext = createContext(null)

export function ShareTokenProvider({ token, children }) {
  return (
    <ShareTokenContext.Provider value={token}>
      {children}
    </ShareTokenContext.Provider>
  )
}

export function useShareContext() {
  return useContext(ShareTokenContext)
}

export function useShareToken() {
  const context = useContext(ShareTokenContext)
  if (!context) return null
  if (typeof context === 'string') return context
  return context.token || null
}

export default ShareTokenContext
